import { useStore } from 'vuex-composition-helpers';
import { computed } from '@vue/composition-api';
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { Provider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/providers/provider';

import { IRootState } from '@/store';
import { User, IUser } from '@/models';

interface IAuthProvider {
  getCurrentUser: IUser;
  isUserAdmin: boolean;
  hasPermission: (permission: string) => boolean;
}

export function useAuth() {
  const store = useStore<IRootState>();

  const provider = computed(
    () => authProvider(store) as Provider & IAuthProvider
  );

  const currentUser = computed<IUser>(
    () => new User(provider.value.getCurrentUser)
  );

  return {
    currentUser
  };
}
